<template>
  <div>
    <div>
      <el-row :gutter="24">
        <el-col :span="6">
            <div class="block">
                <el-date-picker size="mini" v-model="params.times" clearable type="daterange"
                    :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期" align="right">
                </el-date-picker>
            </div>
        </el-col>
        <el-col :span="7">
          <el-button type="primary" @click="searchData" size="mini">搜索</el-button>
             <!-- <el-button type="primary" size="mini" icon="plus" @click="getExport()">导出数据</el-button> -->
        </el-col>
      </el-row>
      <el-table :data="dataList" :height="wheight - 130" v-loading="loading">
        <el-table-column prop="date" label="时间"></el-table-column>
        <el-table-column prop="url" label="地址">
          <template slot-scope="scope">
            <!-- <a :href="scope.row.url" target="_blank">下载</a> -->
            <el-button type="primary" @click="downloadFile1(scope.row)" size="mini">下载</el-button>
          </template>
          </el-table-column>
      </el-table>
      <div class="content-center content-top-padded">
        <el-pagination background layout="total, sizes, prev, pager, next" @current-change="handleCurrentChange"
          @size-change="handleSizeChange" :current-page.sync="params.page" :page-sizes="[10, 20, 50]"
          :total="total_count" :page-size="params.pagesize">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    mapGetters
  } from "vuex";
  import draggable from "vuedraggable";
  import {
    getMonthUrlLog, downloadFile
  } from "../../../api/trade";
  export default {
    components: {
      draggable
    },
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        dialogVisible: false,
        total_count: 0,
        params: {
          page: 1,
          pagesize: 20,
        },
        dataList: [],
        loading: false,
        id: "",
        row: [],
        moneyList: [],
        title: '',
      };
    },
    computed: {
      ...mapGetters(["wheight"]),
    },
    methods: {

      getDataList() {
        this.loading = true;
        getMonthUrlLog(this.params)
          .then((response) => {
            this.dataList = response.data.data.list;
            this.total_count = response.data.data.total_count;
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            this.$message({
              type: "error",
              message: "获取列表信息出错",
            });
          });
      },
      handleCurrentChange(page_num) {
        this.params.page = page_num;
        this.getDataList();
      },
      searchData() {
        this.params.page = 1;
        this.getDataList();
      },
      downloadFile1(row) {
        let params = {
          id: row.id
        };
        downloadFile(params).then((res) => {
          this.$message({
            type: "success",
            message: "下载成功",
          });
          window.open(res.data.data.url);
        });
      },
      handleSizeChange(pageSize) {
        this.params.page = 1;
        this.params.pagesize = pageSize;
        this.getDataList();
      },
    },
    mounted() {

      this.getDataList();

    },
  };
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    img {
      width: 90%;
    }
  }

  .el-col {
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// list.vue?1d0de44e